export const APP_INFO_SET_PREVIOUS_LINK = 'APP_INFO_SET_PREVIOUS_LINK'
export const APP_INFO_SET_ACTIVE_ITEM_ID = 'APP_INFO_SET_ACTIVE_ITEM_ID'
export const APP_INFO_SET_INTERNET_IS_LOST = 'APP_INFO_SET_INTERNET_IS_LOST'
export const APP_INFO_SET_NOTIFICATION_VISIBLE = 'APP_INFO_SET_NOTIFICATION_VISIBLE'
export const APP_INFO_SET_WRAPPER_VERSION = 'APP_INFO_SET_WRAPPER_VERSION'
export const APP_INFO_RELEASE_NAME = 'APP_INFO_RELEASE_NAME'
